import React, { useEffect, useState } from 'react'
import ModalContainerModule from '../modules/modalContainer';
import { DetailsColumn, DetailsContainer, DetailsLabel, DetailsRow, DetailsText } from '../../constants/component.constants';
import { formatCurrency, formatDate, isNullUndefined, tryParseFloat } from '../../util/util';
import { ResponsiveRow } from '../../constants/layout.constants';
import { Alert, AlertTitle, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import { DocumentStore } from '../documentStore';

function ViewRsrModal(props) {
  const [chargeItems, ] = useState(props?.rsrItem?.leaseCharges)
  const [vatPercentage, ] = useState(props?.rsrItem?.vatPercentage)
  const [rsrTableRows, setRsrTableRows] = useState(null)
  const [rsrTotal, setRsrTotal] = useState(0)

  useEffect(() => {
    if (chargeItems && chargeItems.length > 0) {
      populateLeaseChargeItems()
    }
  }, [chargeItems])

  function populateLeaseChargeItems() {
    let rows = ""
    let total = 0
    chargeItems &&
      chargeItems.length > 0 &&
      (rows = chargeItems.map(function (charge, i) {
        let amount = tryParseFloat(charge.total ?? charge.amount, -1)
        if (amount > 0) {
          total = total + amount
        }
        let serviceChargeVat = 0
        if(charge?.chargeCode === "SERCH") {
          serviceChargeVat = charge?.amount * vatPercentage 
          total = total + serviceChargeVat
        }
        return (
          <TableRow key={i}>
            <TableCell>
              <Tooltip title={charge?.unitName}>
                <TextField
                  sx={{ width: "90%" }}
                  id={"unit" + i}
                  name={"unit" + i}
                  isrequired={true}
                  disabled={true}
                  value={charge?.unitName}
                />
              </Tooltip>
            </TableCell>
            <TableCell>
              <Tooltip title={charge?.charge?.name}>
                <TextField
                  sx={{ width: "90%" }}
                  id={"chargeCode" + i}
                  name={"chargeCode" + i}
                  isrequired={true}
                  disabled={true}
                  value={charge?.charge?.name}
                />
              </Tooltip>
            </TableCell>
            <TableCell>
              {charge.chargeCode === "REN" && (
                <TextField
                  sx={{ width: "90%" }}
                  id={"revenueForPeriod" + i}
                  name={"revenueForPeriod" + i}
                  isrequired={true}
                  disabled={true}
                  value={charge?.revenueForThePeriod}
                  // onChange={(event) => handleRevenueForPeriodChange(event, i)}
                />
              )}
            </TableCell>
            <TableCell>
              {charge.chargeCode === "REN" && (
                <Tooltip title={`${charge?.revSharePercentage}%`}>
                  <TextField
                    sx={{ width: "90%" }}
                    id={"revenueShare"}
                    name={"revenueShare"}
                    disabled={true}
                    value={charge?.revSharePercentage}
                  />
                </Tooltip>
              )}
            </TableCell>
            <TableCell>
              {(charge.chargeCode === "SERCH" ||
                charge.chargeCode === "REN" ||
                charge.chargeCode === "ELCUT") && (
                <Switch
                  checked={charge?.taxable}
                  disabled={true}
                  inputProps={{ "aria-label": "controlled" }}
                />
              )}
            </TableCell>
            <TableCell>
              {(charge.chargeCode === "SERCH" ||
                charge.chargeCode === "REN" ||
                charge.chargeCode === "ELCUT") && (
                <Tooltip title={charge?.chargeCode === "SERCH" ? serviceChargeVat : charge?.vat ?? 0}>
                  <TextField
                    sx={{ width: "90%" }}
                    id={"vat" + i}
                    name={"vat" + i}
                    isrequired={true}
                    disabled={true}
                    value={charge?.chargeCode === "SERCH" ? serviceChargeVat : charge?.vat ?? 0}
                  />
                </Tooltip>
              )}
            </TableCell>
            <TableCell>
              <Tooltip title={charge?.total ?? charge?.amount}>
                <TextField
                  sx={{ width: "90%" }}
                  id={"total" + i}
                  name={"total" + i}
                  isrequired={true}
                  disabled={true}
                  value={charge.total ?? charge?.amount}
                />
              </Tooltip>
            </TableCell>
          </TableRow>
        )
      }, this))
    setRsrTableRows(rows)
    setRsrTotal(total)
  }
  return (
    <ModalContainerModule
      size={"md"}
      cancel={props.handleClose}
      openModal={props.open}
      cancelText="Close"
      modalTitle="View Revenue Sharing Request"
    >
      <ResponsiveRow sx={{ paddingTop: 0, height: "auto" }}>
        <DetailsContainer sx={{ width: "100%", height: "auto", marginTop: 0 }}>
          <DetailsColumn
            sx={{
              width: { lg: "50%", md: "100%", xs: "100%" },
            }}
          >
            <DetailsRow>
              <DetailsLabel>Completed by:</DetailsLabel>
              <DetailsText>{props?.rsrItem?.completedByName}</DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Completed Date:</DetailsLabel>
              <DetailsText>
                {isNullUndefined(props?.rsrItem?.completedOn) ? "" : formatDate(props?.rsrItem?.completedOn)}
              </DetailsText>
            </DetailsRow>
          </DetailsColumn>
          <DetailsColumn
            sx={{
              width: { lg: "50%", md: "100%", xs: "100%" },
            }}
          >
            <DetailsRow>
              <DetailsLabel>Description:</DetailsLabel>
              <DetailsText>{props?.rsrItem?.description}</DetailsText>
            </DetailsRow>
          </DetailsColumn>
        </DetailsContainer>
      </ResponsiveRow>
      <Alert severity="info" sx={{ marginBottom: "25px", width: "100%" }}>
        <AlertTitle>Important</AlertTitle>
        <p>
          Below is a breakdown of the Revenue Sharing Request. <br />
          Utility charges are not displayed.
        </p>
      </Alert>
      <Paper
        variant=""
        sx={{
          width: "100%",
          height: "auto",
          margin: "auto",
          padding: "10px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{ marginBottom: "5px" }}
          id="modal-modal-title"
          variant="h5"
          component="h4"
        >
          Revenue Details
        </Typography>
        <TableContainer>
          <Table
            sx={{ minWidth: 650, marginBottom: "10px" }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: "13%" }}>Unit</TableCell>
                <TableCell sx={{ width: "13%" }}>Charge Type</TableCell>
                <TableCell sx={{ width: "20%" }}>Revenue</TableCell>
                <TableCell sx={{ width: "10%" }}>Revenue Share(%)</TableCell>
                <TableCell sx={{ width: "7%" }}>Taxed?</TableCell>
                <TableCell sx={{ width: "20%" }}>VAT</TableCell>
                <TableCell sx={{ width: "20%" }}>Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{rsrTableRows}</TableBody>
          </Table>
          <ResponsiveRow sx={{ width: '100%' }}>
            <b>Total</b> {`: KES ${formatCurrency(rsrTotal)}`}
          </ResponsiveRow>
        </TableContainer>
      </Paper>
      <ResponsiveRow sx={{ paddingTop: 0, height: "auto" }}>
        <Typography variant="h4">Attachments</Typography>
        <DocumentStore
          files={
            props?.rsrItem?.imageFiles && props?.rsrItem?.otherDocuments
              ? [
                  ...props?.rsrItem?.imageFiles,
                  ...props?.rsrItem?.otherDocuments,
                ]
              : []
          }
          item={props.rsrItem}
          type={"RSR Invoice"}
          disableShadow
          height="300px"
          maxWidth="100%"
          horizontalLayout={true}
        />
        {/* </DetailsContainer> */}
      </ResponsiveRow>
    </ModalContainerModule>
  );
}

export default ViewRsrModal